const DEFAULT_ADMIN_EMAILS = [
  'lunzhitianqi@gmail.com',
]

export const getAdminEmails = () => {
  const configured = (import.meta.env.VITE_ADMIN_EMAILS || '')
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean)

  return Array.from(new Set([...DEFAULT_ADMIN_EMAILS, ...configured]))
}

export const isAdminEmail = (email) => {
  if (!email) return false
  return getAdminEmails().includes(String(email).toLowerCase())
}
